import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { saveAs } from 'file-saver';
import { FormControl, FormGroup } from '@angular/forms';
import { EventServicesService } from 'src/app/services/event-services.service';
import { SharedServicesService } from 'src/app/services/shared-services.service';
import { Router } from '@angular/router';
import { GlobalServicesService } from 'src/app/services/global-services.service';
import { BreadcrumbService   } from 'xng-breadcrumb';
import { ActivatedRoute } from '@angular/router';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { ChangeDetectorRef } from '@angular/core';
import { ViewPreferencesCacheService, ViewPreferences } from 'src/app/services/view-preferences-cache.service';
import { Subscription } from 'rxjs';

interface ColumnDisplayNames {
  [key: string]: string;
  event_status: string;
  institution_address: string;
  event_start_date: string;
  event_end_date: string;
  registration_start_date: string;
  registration_end_date: string;
  created_at: string;
  created_by: string;
  job_roles: string;
  institutes: string;
}
@Component({
    selector: 'app-events-list',
    templateUrl: './events-list.component.html',
    styleUrls: ['./events-list.component.css'],
    providers: [MessageService],
    standalone: false
})
export class EventsListComponent implements OnInit, OnDestroy {

  eventsList: Array<any> = [];
  pageLimits: Array<any> = [];
  status: MenuItem[] = [];
  eventsCol: Array<any> = []
  _selectedColumns: Array<any> = []
  selectedEvents: Array<any> = [];
  selectAllColumns: boolean = false;
  _eventsCol: Array<any> = [];
  colsToDownload: Array<any> = [];
  columnsToSave: Array<any> = [];
  savedColumnSettings: Array<any> = [];
  checkedColumns: Array<any> = [];
  cloneEventData: any = {};
  eventJobData: any = {};
skeletonData: any[] = Array(10).fill({}).map((_, index) => ({
  id: `skeleton-${index}`,
  name: '',
  event_status: '',
  job_roles: [],
  institutes: [],
  created_by: { first_name: '', last_name: '' },
  event_start_date: '',
  event_end_date: '',
  registration_start_date: '',
  registration_end_date: '',
  created_at: '',
  activeCount: 0,
  hiredCount: 0,
  appliedCount: 0,
  candidateCount: 0
}));
  addEventSlider: boolean = false
  loadingSpinner: boolean = false;
  showFilterSidebar: boolean = false;
  showSettingsSidebar: boolean = false;
  showDownloadSidebar: boolean = false;
  displaySaveFilterSettings: boolean = false;
  displaySaveColumnSettings: boolean = false;
  loadingDownload: boolean = false;
  
  first: number = 1;
  last: number = 10;
  pageSize: number = 25;
  pageNumber: number = 1;
  totalLength: number = 0;
  totalPages: number = 1;

  order_by: string = 'desc';
  sort_by: string = 'created_at';
  innerHeight: string = '';
  statusSelected: string = 'All';
  columnSearchTerm: string = '';
  filterSearchTerm: string = '';
  downloadSearchTerm: string = '';
  columnFieldId: string = '';
  downloadAs: string = 'excel';
  exportName: string = 'EventList';
  privilege: any = {};
  userRole: string = '';
  dateFormat: any;
  userPrivileges: Set<string> = new Set();
  timeFormat: any;
  combineFormat: any;

  // Cache service properties
  private readonly CACHE_ROUTE_KEY = 'events-list';
  private cacheSubscription: Subscription = new Subscription();

  constructor(
    private eventServices: EventServicesService, 
    private _sharedService: SharedServicesService, 
    private _router: Router, 
    private globalService: GlobalServicesService, 
    private breadcrumbService: BreadcrumbService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
    private viewPreferencesCache: ViewPreferencesCacheService
  ) {
    this.innerHeight = String(window.innerHeight * 0.7);
    this.pageLimits = [10, 25, 50, 100];
    this.status = [
      {
        label: 'All',
        command: () => {
          this.statusSelected = 'All';
          this.getEventsByFilter('all');
        },
      },
      {
        label: 'Saved',
        command: () => {
          this.statusSelected = 'Saved';
          this.getEventsByFilter('saved');
        },
      },
      {
        label: 'Upcoming',
        command: () => {
          this.statusSelected = 'Upcoming';
          this.getEventsByFilter('upcoming');
        },
      },
      {
        label: 'Ongoing',
        command: () => {
          this.statusSelected = 'Ongoing';
          this.getEventsByFilter('ongoing');
        },
      },
      {
        label: 'Completed',
        command: () => {
          this.statusSelected = 'Completed';
          this.getEventsByFilter('completed');
        },
      },
    ];

    this.eventsCol = [
      { index: 1, field: 'job_roles', header: 'Job Role', sortable: false },
      { index: 2, field: 'event_status', header: 'Event Status', sortable: false },
      { index: 3, field: 'total_count', header: 'Total Count', sortable: true },
      { index: 4, field: 'new_count', header: 'Applied', sortable: true },
      { index: 5, field: 'active_count', header: 'Active Count', sortable: true },
      { index: 6, field: 'hired_count', header: 'Hired Count', sortable: true },
      { index: 7, field: 'institutes', header: 'Institution Name', sortable: false },
      { index: 8, field: 'institution_address', header: 'Location', sortable: false },
      { index: 9, field: 'created_by', header: 'Created By', sortable: false },
      { index: 10, field: 'event_start_date', header: 'Start Date', sortable: true },
      { index: 11, field: 'event_end_date', header: 'End Date', sortable: true },
      { index: 12, field: 'registration_start_date', header: 'Registration Start Date', sortable: true },
      { index: 13, field: 'registration_end_date', header: 'Registration End Date', sortable: true },
      { index: 14, field: 'created_at', header: 'Created Date', sortable: true },
    ]

    this._selectedColumns = [
      { index: 2, field: 'event_status', header: 'Event Status', sortable: false },
      { index: 1, field: 'job_roles', header: 'Job Role', sortable: false },
      {index: 7, field: 'institutes', header: 'Institution Name', sortable: false },
      {index: 8, field: 'institution_address', header: 'Location', sortable: false },
      { index: 9, field: 'created_by', header: 'Created By', sortable: false },
      { index: 10, field: 'event_start_date', header: 'Start Date', sortable: true },
      { index: 11, field: 'event_end_date', header: 'End Date', sortable: true },
      // { index: 12, field: 'registration_start_date', header: 'REGISTRATION START DATE', sortable: true },
      // { index: 13, field: 'registration_end_date', header: 'REGISTRATION END DATE', sortable: true },

    ]
  }

  columnSettings: FormGroup = new FormGroup({
    name: new FormControl(''),
    saved_columns: new FormControl(this.columnsToSave)
  })

  setGlobalStatus(status: string) {
    this.globalService.status = status
  }

  ngOnInit(): void {
    this.dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details') || '{}').company_settings?.date_format : '';
    this.timeFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details') || '{}').company_settings?.time_format : '';
    this.combineFormat = this.timeFormat == 'hh:mm' ? this.dateFormat  + '  '+ this.timeFormat + ' a' : this.dateFormat  + '  '+ this.timeFormat;
    this._eventsCol = this.eventsCol;
    this.colsToDownload = this.eventsCol;
    this.checkedColumns = this._selectedColumns;
    
    this.loadCachedPreferences();
    
    this.globalService.privilegeDetailsSubject.subscribe((privileges) => {
      this.userPrivileges = privileges;
    });
    this.userRole = this.globalService.privilegeRoles;
    if (this.userPrivileges.has('event.view')) {
      this.route.queryParams.subscribe(params => {
        const status = params['event_status'] || 'all';
        this.statusSelected = status.charAt(0).toUpperCase() + status.slice(1);
        this.getAllEvents(status);
      });
    }    
    // this.getColumnId();
    // this.getSavedColumns();
    this.globalService.searchList.subscribe((response) => {
      this.pageNumber = 1
      this.eventsList = Object.keys(response.items).length !== 0 ? response.items : [];
      this.eventsList.forEach((eachData) => {
        eachData.appliedCount = eachData.new_count || 0;
        eachData.activeCount = eachData.active_count || 0;
        eachData.hiredCount = eachData.hired_count || 0;
        eachData.candidateCount = eachData.total_count || 0;
        eachData.id = eachData.uuid;
      });
      this.totalLength = response.total || 0;
      this.first = response.page || 1;
      this.last = response.pages || 10;
      this.pageSize = response.size || 10;
      this.totalPages = response.pages || 1;
      this.loadingSpinner = false;
    })
    this.updateBreadcrumb();
  }

  exportAllEvents = (type: string) => {
    const validColumns = [
      "job_roles",
      "event_status",
      "institutes",
      "institution_address",
      "created_by",
      "event_start_date",
      "event_end_date",
      "registration_start_date",
      "registration_end_date",
      "created_at",
      "active_count",
      "hired_count",
      "total_count",
      "new_count"
    ];
    const columnDisplayNames: ColumnDisplayNames = {
      event_status: 'Event Status',
      institution_address: 'Institution Address',
      event_start_date: 'Event Start Date',
      event_end_date: 'Event End Date',
      registration_start_date: 'Registration Start Date',
      registration_end_date: 'Registration End Date',
      created_at: 'Created Date',
      created_by: 'Created By',
      job_roles: 'Job Roles',
      institutes: 'Institutes'
    };
    if (!this.checkedColumns || this.checkedColumns.length === 0) {
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Please select at least one column to download'
      });
      return;
    }
  
    const selectedColumns = this.checkedColumns.map(col => col.field);
    const invalidColumns = selectedColumns.filter(col => !validColumns.includes(col));  
    if (invalidColumns.length > 0) {
      const invalidDisplayNames = invalidColumns
      .map((col: keyof ColumnDisplayNames) => columnDisplayNames[col] || col)
      .join(', ');
        
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: `These columns are not available for download: ${invalidDisplayNames}. Proceeding with available columns.`
      });
    }
    let validSelectedColumns = selectedColumns
    .filter(col => validColumns.includes(col))
    validSelectedColumns = ['name', ...validSelectedColumns.filter(col => col !== 'name')];
  if (validSelectedColumns.length === 1) {
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: 'No valid columns selected for download'
    });
    return;
  }
    this.loadingDownload = true;
    const normalizedStatus = this.statusSelected.toLowerCase();    
    let searchTerm: string = '';
    const globalSearchTerm = this.globalService.searchTerm;
    if (globalSearchTerm && globalSearchTerm.trim()) {
      const searchedEvent = globalSearchTerm.trim().split(/\s+/);
      if (searchedEvent.length === 1) {
        searchTerm = searchedEvent[0];
      } else if (searchedEvent.length > 0) {
        searchTerm = searchedEvent.join(' ');
      }
    }
    const payload = {
      file_type: type,
      columns: validSelectedColumns,
      requested_data: "all",
      ids: null,
      event_status: normalizedStatus,
      search: searchTerm || null
    };
  
    this.eventServices.exportAllEvents(payload).subscribe({
      next: (response) => {
        this.loadingDownload = false;
        const message = response.body?.message || 'Export process has been initiated successfully.';
        
        this.messageService.add({
          severity: 'success',
          summary: 'Process Started',
          detail: message
        });
        this.showDownloadSidebar = false;
        this.resetCheckedColumnsToDefault();
      },
      error: (error: HttpErrorResponse) => {
        this.loadingDownload = false;
        let errorMessage = 'Failed to download events data';
        if (error.error && error.error.detail && Array.isArray(error.error.detail)) {
          const firstError = error.error.detail[0];
          errorMessage = firstError.msg || firstError.ctx?.error || errorMessage;
        } else if (error.error?.message) {
          errorMessage = error.error.message;
        } else if (error.error?.detail) {
          errorMessage = error.error.detail;
        }
        
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: errorMessage
        });
      }
    });
  }

  getStatusClass(status: string): string {
    switch ((status || '').toLowerCase()) {
      case 'upcoming': return 'status-upcoming';
      case 'ongoing': return 'status-ongoing';
      case 'saved': return 'status-saved';
      case 'completed': return 'status-completed';
      default: return '';
    }
  }
  
  updateBreadcrumb(): void {
    this.breadcrumbService.set('@events', 'Manage Events');
  }
  

  getAllEvents = (status: string = 'all') => {
    this.totalLength = 0;
    this.loadingSpinner = true;
    const normalizedStatus = status.toLowerCase();
    this.globalService.pageNumber = this.pageNumber;
    this.globalService.pageSize = this.pageSize;
    let searchTerm = this.globalService.searchTerm;
    let searchedEvent = searchTerm.trim().split(/\s+/);
    searchTerm = '';
    if (searchedEvent && searchedEvent.length === 1) {
      searchTerm = searchedEvent[0];
    } else if(searchedEvent.length > 0) {
      searchTerm = searchedEvent.join(' ');
    }
  
    this.eventServices.getEventsFastApi(
      this.pageNumber, 
      this.pageSize, 
      this.order_by, 
      this.sort_by, 
      searchTerm || undefined, 
      normalizedStatus 
    ).subscribe({
      next: (response: any) => {
        this.eventsList = Object.keys(response.body.items).length !== 0 ? response.body.items : [];
        this.eventsList.forEach((eachData) => {
          eachData.appliedCount = eachData.new_count || 0;
          eachData.activeCount = eachData.active_count || 0;
          eachData.hiredCount = eachData.hired_count || 0;
          eachData.candidateCount = eachData.total_count || 0;
          eachData.id = eachData.uuid;
        });
        this.totalLength = response.body.total || 0;
        this.first = response.body.page || 1;
        this.last = response.body.pages || 10;
        this.pageSize = response.body.size || 10;
        this.totalPages = response.body.pages || 1;
        this.loadingSpinner = false; 
      },
      error: () => {
        this.loadingSpinner = false;
      }
    });
  }

  onCloseEventSlider(success: boolean) {
    this.addEventSlider = false;
    this.closeEventSideBar()
  }

  getEventsByLimit = () => {
    if (!this.userPrivileges.has('event.view')) {
      return;
    }
    this.showFilterSidebar = false;
    this.showSettingsSidebar = false;
    this.showDownloadSidebar = false;
    this.pageNumber = 1;
    this.first = 1;
    this.last = this.pageSize < this.totalLength ? this.pageSize : this.totalLength;
    
    // Save preferences when page size changes
    this.saveCurrentPreferences();
    
    this.statusSelected === 'All' ? this.getAllEvents('all') : this.getAllEvents(this.statusSelected);
  };
  

  getEventsByFilter = (status: string) => {
    if (!this.userPrivileges.has('event.view')) {
      return;
    }
    this.setGlobalStatus(status);
    this.pageNumber = 1;
    this.first = 1;
    this.last = this.pageSize < this.totalLength ? this.pageSize : this.totalLength;
    
    // Save preferences when filter changes
    this.saveCurrentPreferences();
    
    this.getAllEvents(status);
  };


  saveColumnSettings = () => {
    this.loadingSpinner = true;
    this.columnsToSave = this.checkedColumnsBackup.map(e => e.field);

    this.columnSettings.setValue({
      name: this.columnSettings.get("name")?.value,
      saved_columns: this.columnsToSave
    });

    this.eventServices.saveUserPreferencesFastApi(this.columnSettings.value, 'event').subscribe({
      next: (result: any) => {
        this.getSavedColumns();
        this.loadingSpinner = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: result.body.detail,
        });
        this.clearColumnPreferenceName();
      },
      error: () => {
        this.loadingSpinner = false;
      }
    });
    this.clearColumnPreferenceName();
  }

  getSavedColumns = () => {
    this.eventServices.getUserPreferencesFastApi('event').subscribe(res => {
      this.savedColumnSettings = res.body.user_preferences ? res.body.user_preferences : []
    });
  }

  deleteSavedColumns = (columnId: string) => {
    this.loadingSpinner = true;
    this.eventServices.deleteUserPreferencesFastApi(columnId).subscribe({
      next: res => {
      this.getSavedColumns();
      this.loadingSpinner = false;
    },
    error: () => {
      this.loadingSpinner = false; // Handle error case
    }
  });
  }

  deleteEvent = (event: any) => {
    this.loadingSpinner = true;
    this.eventServices.deleteEventFastApi(event.uuid.toString()).subscribe({
      next: (res: any) => {
        if (res.status === 200) {
          this.selectedEvents = [];
          this.messageService.add({ severity: 'success', summary: 'Success', detail: res.body.detail });
          if (this.userPrivileges.has('event.view')) {
            this.getAllEvents();
          }
        }
        this.loadingSpinner = false;
      },
      error: (_err: any) => {
        this.loadingSpinner = false;
      }
    });
  }

  searchColumns = (searchTerm: string) => {
    if (this.showSettingsSidebar) {
      this._eventsCol = this.eventsCol.filter(val => val.header.toLowerCase().includes(searchTerm.toLowerCase()));
    }

    if (this.showDownloadSidebar) {
      this.colsToDownload = this.eventsCol.filter(val => val.header.toLowerCase().includes(searchTerm.toLowerCase()));
    }
  }

  setStatus = (status: string) => {
    this.statusSelected = status;
  }

  getEventVal = (event: Event) => {
    return (event.target as HTMLInputElement).value;
  }

  onSelectedEventChange = (value: []) => {
    this.selectedEvents = value;
  }

  isStringsArray(array: any) {
    return array.every((element: any) => typeof element === "string");
  }

  exportEvent = (fileType?: string) => {
    let checkedColumnFields: any = ['name'];
    this.checkedColumns.forEach((each) => {
      checkedColumnFields.push(each.field);
    });
    let afterFilter: any = [];
    const eventToExport = this.selectedEvents.length > 0 ? this.selectedEvents : this.eventsList;
    eventToExport.forEach((eachData: any) => {
      let filterData: any = {};
      checkedColumnFields.forEach((item: any) => {
        if(eachData.hasOwnProperty(item)) {
          if(Array.isArray(eachData[item]) && this.isStringsArray(eachData[item])){
            filterData[item] = eachData[item].join(", ");
          }
          else
          {
            filterData[item] = eachData[item];
          }
        }
      });
      if (checkedColumnFields.find((element: string) => element === 'job_roles')) {
        filterData['job_roles'] = eachData.job_roles
          .map((role: { name: any; }) => role.name)
          .join(', ');
      }
      if (checkedColumnFields.find((element: string) => element === 'institutes')) {
        filterData['institutes'] = eachData.institutes
          .map((institute: { name: any; }) => institute.name)
          .join(', ');
      }
      if (checkedColumnFields.find((element: string) => element === 'created_by')) {
        filterData['created_by'] = `${eachData.created_by.first_name} ${eachData.created_by.last_name}`.trim();
      }
      afterFilter.push(filterData);
    });
    this.saveAsExcelFile(afterFilter, this.exportName, fileType);
  }

  escapeCSVValue = (value: any) => {
    if (typeof value === "string" && value.includes(",")) {
      return `"${value.replace(/"/g, '""')}"`;
    }
    return value;
  };

  saveAsExcelFile( data: any, fileName: string, type?: string): void {
    if (type === "csv") {
      const headers = Object.keys(data[0]).join(",");
      const rows = data .map((obj: { [s: string]: any; } | ArrayLike<unknown>) =>
        Object.values(obj)
          .map(value => this.escapeCSVValue(value))
          .join(",")
      )
      .join("\n");
      const csvContent = `${headers}\n${rows}`;
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      saveAs(blob, `${fileName}_export_${ new Date().getTime()}.csv`);
      this.messageService.add({
        severity: 'success',
        summary: 'Export Successful',
        detail: 'CSV file has been downloaded successfully'
      });
      this.showDownloadSidebar = false;
      this.resetCheckedColumnsToDefault();
  
    } else if (type === "Excel") {
      import("xlsx").then(XLSX => {
        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Events");
        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(blob, `${fileName}_export_${ new Date().getTime()}.xlsx`);
        this.messageService.add({
          severity: 'success',
          summary: 'Export Successful',
          detail: 'Excel file has been downloaded successfully'
        });
        this.showDownloadSidebar = false;
        this.resetCheckedColumnsToDefault();
      });
  }
  }

  applySelectedColumns = () => {
    this.checkedColumns = this.checkedColumnsBackup;
    this._selectedColumns = this.sortedColumns();
    this.showSettingsSidebar = false;
  }

  clearSelectedColumns = () => {
    this.checkedColumns = [];
  }
  resetCheckedColumnsToDefault(): void {
    this.checkedColumns = [...this._selectedColumns];
    this.selectAllColumns = this.checkedColumns.length === this.colsToDownload.length;
  }
  applySavedSettings = (savedColumnValue: Array<any>) => {
    this.checkedColumnsBackup = this.eventsCol.filter(e => savedColumnValue.includes(e.field));
    this.checkedColumnsFields = this.checkedColumnsBackup.map((col) => col.field);
  }

  openCandidates(eventId: string, category: string = 'technical') {
    const viewParam = this.userRole === 'interviewer' || this.userRole === 'evaluator' ? 'workflow' : 'overview';
    const selectedEvent = this.eventsList.find(event => event.uuid === eventId);
    const eventName = selectedEvent ? selectedEvent.name : '';
    this._router.navigate(['events/', eventId], { queryParams: { view: viewParam } ,state: { eventName: eventName }});
  }  

  private sortedColumns(): any[] {
    return this.checkedColumns.sort((a, b) => (a.index < b.index) ? -1 : 1);
  }

  next(): void {
    this.showFilterSidebar = false;
    this.showSettingsSidebar = false;
    this.showDownloadSidebar = false;
    this.selectedEvents = [];
    this.first = this.first + this.pageSize;
    this.last = this.last + this.pageSize < this.totalLength ? this.pageSize + this.last : this.totalLength;
    this.pageNumber += 1;
    
    this.saveCurrentPreferences();
    
    const currentFilter = this.statusSelected === 'All' ? 'all' : this.statusSelected.toLowerCase();
    this.getAllEvents(currentFilter);
  }
  
  prev(): void {
    if (!this.userPrivileges.has('event.view')) {
      return;
    }
    this.showFilterSidebar = false;
    this.showSettingsSidebar = false;
    this.showDownloadSidebar = false;
    this.selectedEvents = [];
    this.first = this.first - this.pageSize;
    this.last = this.last - this.pageSize > this.pageSize ? ( this.last == this.totalLength ? this.totalLength - this.eventsList.length : this.last - this.pageSize ) : this.pageSize;
    this.pageNumber -= 1;
    
    this.saveCurrentPreferences();
    
    const currentFilter = this.statusSelected === 'All' ? 'all' : this.statusSelected.toLowerCase();
    this.getAllEvents(currentFilter);
  }

  isLastPage(): boolean {
    return !this.totalPages || this.pageNumber === this.totalPages;
  }

  isFirstPage(): boolean {
    return this.first > 1 ? false : true;
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    this._selectedColumns = this.eventsCol.filter(col => val.includes(col));
  }

  async cloneEvent(event: any){
    this.loadingSpinner = true;

    this.cloneEventData = {...event};
    this.cloneEventData.eventTitle = '';
    this.cloneEventData.registrationStartDate = '';
    this.cloneEventData.registrationEndDate = '';
    this.cloneEventData.eventStartDate = '';
    this.cloneEventData.eventEndDate = '';

    this.addEventSlider = true;
    setTimeout(() => {
      this.loadingSpinner = false;
      this.cdRef.detectChanges();
    }, 0);
    // this.eventServices.getEventJobById(event.id, event.id).subscribe(response => {
    //   this.eventJobData = response.data ? response.data : [];
    // })
  }

  eventCloned = (cloned:boolean) => {
    if(cloned){
      this.addEventSlider = false;
      this.selectedEvents = [];
    }
  }
  closeEventSideBar(){
      this.selectedEvents = [];
      this.cloneEventData = {};
      if (this.userPrivileges.has('event.view')) {
        this.getAllEvents();
      }
  }
  onClickSettingsSidebar(): void {
    this.showSettingsSidebar = true;
    this.showFilterSidebar = false;
    this.showDownloadSidebar = false;
    this.getSavedColumns();
  }
toggleSelectAll(): void {
  if (this.selectAllColumns) {
    this.checkedColumns = [...this.colsToDownload];
  } else {
    this.checkedColumns = [...this._selectedColumns];
  }
  this.selectAllColumns = this.checkedColumns.length === this.colsToDownload.length;
  this.cdRef.detectChanges();
}
onColumnCheckChange(): void {
  this.selectAllColumns = this.checkedColumns.length === this.colsToDownload.length;
  this.cdRef.detectChanges();
}
getJobRolesTooltip(jobRoles: any[]): string {
  if (!jobRoles || jobRoles.length <= 1) return '';
  
  const remainingRoles = jobRoles.slice(1);
  const tooltipContent = remainingRoles.map((role, index) => 
    `<div class="tooltip-item">${role.name || '-'}</div>`
  ).join('');
  
  return `<div class="tooltip-content">${tooltipContent}</div>`;
}

getInstitutesTooltip(institutes: any[]): string {
  if (!institutes || institutes.length <= 1) return '';
  
  const remainingInstitutes = institutes.slice(1);
  const tooltipContent = remainingInstitutes.map((institute, index) => 
    `<div class="tooltip-item">${institute.name || '-'}</div>`
  ).join('');
  
  return `<div class="tooltip-content">${tooltipContent}</div>`;
}
clearColumnPreferenceName(): void {
  this.columnSettings.get('name')?.setValue('');
  this.displaySaveColumnSettings = false;
}


private loadCachedPreferences(): void {
  const defaultPreferences: ViewPreferences = {
    pageSize: 25,
    pageNumber: 1,
    statusFilter: 'all',
    searchTerm: '',
    sortBy: 'created_at',
    orderBy: 'desc',
    selectedColumns: this._selectedColumns
  };

  const cachedPreferences = this.viewPreferencesCache.getPreferencesWithDefaults(
    this.CACHE_ROUTE_KEY, 
    defaultPreferences
  );

  if (cachedPreferences) {
    this.pageSize = cachedPreferences.pageSize || 25;
    this.pageNumber = cachedPreferences.pageNumber || 1;
    this.statusSelected = cachedPreferences.statusFilter ? 
      cachedPreferences.statusFilter.charAt(0).toUpperCase() + cachedPreferences.statusFilter.slice(1) : 'All';
    this.sort_by = cachedPreferences.sortBy || 'created_at';
    this.order_by = cachedPreferences.orderBy || 'desc';
    
    if (cachedPreferences.selectedColumns && cachedPreferences.selectedColumns.length > 0) {
      this._selectedColumns = cachedPreferences.selectedColumns;
      this.checkedColumns = [...this._selectedColumns];
    }

    this.first = ((this.pageNumber - 1) * this.pageSize) + 1;
    this.last = Math.min(this.pageNumber * this.pageSize, this.totalLength);
  } else {
    this.pageSize = 25;
    this.pageNumber = 1;
    this.statusSelected = 'All';
    this.first = 1;
    this.last = this.pageSize;
  }
}


private saveCurrentPreferences(): void {
  const preferences: ViewPreferences = {
    pageSize: this.pageSize,
    pageNumber: this.pageNumber,
    statusFilter: this.statusSelected.toLowerCase(),
    searchTerm: '',
    sortBy: this.sort_by,
    orderBy: this.order_by,
    selectedColumns: this._selectedColumns
  };

  this.viewPreferencesCache.savePreferences(this.CACHE_ROUTE_KEY, preferences);
}

refreshTable(): void {
  this.viewPreferencesCache.clearCacheOnRefresh();
  
  this.pageSize = 25;
  this.pageNumber = 1;
  this.statusSelected = 'All';
  this.first = 1;
  this.last = this.pageSize;
  
  this.getAllEvents('all');
}

ngOnDestroy(): void {
  this.saveCurrentPreferences();  
  this.cacheSubscription.unsubscribe();
}

  checkedColumnsFields: string[] = [];
  checkedColumnsBackup: any[] = [];
  updatedSelectedColFields() {
    this.checkedColumnsBackup = JSON.parse(JSON.stringify(this.checkedColumns));
    this.checkedColumnsFields = this.checkedColumnsBackup.map((col) => col.field);
  }

  updateCheckedColumns(event: any) {
    this.checkedColumnsFields = event;
    this.checkedColumnsBackup = this._eventsCol.filter((col) => event.includes(col.field))
  }
}